import { render } from "./Help.vue?vue&type=template&id=7f224656&scoped=true"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"

import "./Help.vue?vue&type=style&index=0&id=7f224656&scoped=true&lang=scss"
import "./Help.vue?vue&type=style&index=1&id=7f224656&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f224656"]])

export default __exports__